<script>
  import "owl.carousel/dist/assets/owl.carousel.css";
  import "owl.carousel";

  import { onMount } from "svelte";

  export let imageLinks = [];

  onMount(() => {
    window.jQuery(".owl-carousel").owlCarousel({
      margin: 20,
      nav: true,
      lazyLoad: true,
    });
  });
</script>

<div class="owl-carousel gallery-carousel owl-theme pb-3">
  {#if imageLinks && imageLinks.length > 0}
    {#each imageLinks as imgLink}
      <div class="item">
        <img src={imgLink} alt="" />
      </div>
    {/each}
  {/if}
</div>
